import React from "react"

import ListWidgetHeader from "../../common/ListWidgetHeader"
import ClusterListContainer from "./ClusterListContainer"
import SearchBar from "../../common/SearchBar"

const ClusterListWidget = ({
    isFetching,
    invalidate,
    pagingRequest,
    nameSearchTerm,
    isAddingEnabled,
    onSearch,
    onAdd
}) => (
    <div className="widget">
        <ListWidgetHeader
            isFetching={isFetching}
            canAdd={isAddingEnabled}
            iconComponent={<span className="icon icon-cluster" />}
            listTitle="Clusters"
            invalidate={invalidate(pagingRequest)}
            onAdd={onAdd}
        />
        <div className="quick-filters">
            <SearchBar
                name="title"
                searchTerm={nameSearchTerm}
                onSearch={onSearch}
            />
        </div>
        <ClusterListContainer />
    </div>
)

export default ClusterListWidget
